import {
  QueryConstraint,
  collection,
  endBefore,
  getCountFromServer,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import {
  TablePaginatedData,
  TablePaginationParams,
  TableSortModel,
} from "shared/types/tables";
import { ModuleData } from "../types";
import { ModuleDB } from "./Modules";

export const getModuleTemplatePagedList = async (
  paginationData: TablePaginationParams,
  sortModel?: TableSortModel,
): Promise<TablePaginatedData<ModuleData>> => {
  const collectionRef = collection(db, "moduleTemplates");

  const params: QueryConstraint[] = [limit(paginationData.limit)];

  if (sortModel) {
    params.push(orderBy(sortModel.sortBy, sortModel.sortDir));
  } else {
    params.push(orderBy("createdAt", "desc"));
  }

  if (paginationData.startListItem) {
    params.push(endBefore(paginationData.startListItem));
  }

  if (paginationData.endListItem) {
    params.push(startAfter(paginationData.endListItem));
  }

  const q = query(collectionRef, ...params);

  const [countSnap, modulesSnap] = await Promise.all([
    getCountFromServer(collectionRef),
    getDocs(q),
  ]);

  return {
    totalCount: countSnap.data().count,
    items: modulesSnap.docs.map((snap) => new ModuleDB(snap).toModule()),
    startListItem: modulesSnap.docs[0],
    endListItem: modulesSnap.docs[modulesSnap.size - 1],
  };
};
